/**
 * Тип основания платежа
 */
export type PaymentReasonTypeId =
    | 'proformaInvoice'
    | 'contractInvoice'
    | 'order'
    | 'shipment'
    | 'orderPosition'
    | 'invoice'
    | 'invoiceOrder'
    | 'invoiceShipment'
    | 'invoiceOffer'
    | 'factoring';

class PaymentReasonType {
    public id: PaymentReasonTypeId;
    public name: string;

    constructor(id: PaymentReasonTypeId, name: string) {
        this.id = id;
        this.name = name;
    }

    static readonly PROFORMA_INVOICE  = new PaymentReasonType('proformaInvoice', 'Proforma Invoice');
    static readonly CONTRACT_INVOICE  = new PaymentReasonType('contractInvoice', 'Договор-счёт');
    static readonly ORDER             = new PaymentReasonType('order', 'Заказ');
    static readonly SHIPMENT          = new PaymentReasonType('shipment', 'Отгрузка');
    static readonly ORDER_POSITION    = new PaymentReasonType('orderPosition', 'Позиция заказа');
    static readonly INVOICE           = new PaymentReasonType('invoice', 'Счёт поставщика');
    static readonly INVOICE_ORDER     = new PaymentReasonType('invoiceOrder', 'Счёт поставщика по заказу');
    static readonly INVOICE_SHIPMENT  = new PaymentReasonType('invoiceShipment', 'Счёт поставщика по отгрузке');
    static readonly INVOICE_OFFER     = new PaymentReasonType('invoiceOffer', 'Счёт-оферта');
    static readonly FACTORING         = new PaymentReasonType('factoring', 'Факторинг');

    static all(): PaymentReasonType[] {
        return [
            PaymentReasonType.PROFORMA_INVOICE,
            PaymentReasonType.CONTRACT_INVOICE,
            PaymentReasonType.ORDER,
            PaymentReasonType.SHIPMENT,
            PaymentReasonType.ORDER_POSITION,
            PaymentReasonType.INVOICE,
            PaymentReasonType.INVOICE_ORDER,
            PaymentReasonType.INVOICE_SHIPMENT,
            PaymentReasonType.INVOICE_OFFER,
            PaymentReasonType.FACTORING,
        ];
    }

    static fromId(id: PaymentReasonTypeId): PaymentReasonType | undefined {
        return this.all().find(type => type.id === id);
    }

    static fromServer(data: any): PaymentReasonType {
        return new PaymentReasonType(data.id, data.name);
    }

    /** Требуется ли выбор отгрузки */
    get requiresShipment(): boolean {
        return ['shipment', 'invoiceShipment', 'factoring'].includes(this.id);
    }

    /** Требуется ли выбор заказа */
    get requiresOrder(): boolean {
        return ['order', 'invoiceOrder'].includes(this.id);
    }

    /** Требуется ли выбор позиции заказа */
    get requiresOrderPosition(): boolean {
        return this.id === 'orderPosition';
    }

    /** Требуется ли ввод данных счёта (номер, дата, валюта) */
    get requiresInvoice(): boolean {
        return this.id.startsWith('invoice')
            || ['proformaInvoice', 'contractInvoice', 'invoiceOffer'].includes(this.id);
    }

    /** Основание на базе счёта без привязки к заказу/отгрузке */
    get isStandaloneInvoice(): boolean {
        return ['invoice', 'proformaInvoice', 'contractInvoice', 'invoiceOffer'].includes(this.id);
    }

    toString(): string {
      return this.name;
    }
}

export default PaymentReasonType;
